'use client'

import React from 'react'

import { ListOrdered } from 'lucide-react'
import { useTranslations } from 'next-intl'

import { Button, type ButtonProps } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip'

import { cn } from '@/utils'

import { useToolbar } from './toolbar-provider'

const OrderedListToolbar = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, className, onClick, ...props }, ref) => {
    const { editor } = useToolbar()
    const t = useTranslations('components.tiptap.toolbars')

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            className={cn(
              'h-8 w-8 p-0 sm:h-9 sm:w-9',
              editor?.isActive('orderedList') && 'bg-accent',
              className
            )}
            disabled={!editor?.can().chain().focus().toggleOrderedList().run()}
            onClick={(e) => {
              editor?.chain().focus().toggleOrderedList().run()
              onClick?.(e)
            }}
            ref={ref}
            size="icon"
            type="button"
            variant="ghost"
            {...props}
          >
            {children ?? <ListOrdered className="h-4 w-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <span>{t('orderedList')}</span>
        </TooltipContent>
      </Tooltip>
    )
  }
)

OrderedListToolbar.displayName = 'OrderedListToolbar'

export { OrderedListToolbar }
